import { IngredientProvider } from 'contexts/Ingredient'
import Navigator from './pages/Navigator'
import React from 'react'
import { TranslationsProvider } from 'contexts/Translation'

/**
 * It returns a React component that renders a TranslationsProvider and a Navigator.
 * @returns The <TranslationsProvider> component.
 */
function App() {
  return (
    <TranslationsProvider>
      <IngredientProvider>
        <Navigator />
      </IngredientProvider>
    </TranslationsProvider>
  )
}

export default App
